import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { bookAppointment } from '../lib/bookAppointment.js';

/**
 * Handler for ScheduleAppointmentModal's onSubmit: books the event, reports what happened, refreshes calendars.
 * @param {string} leadId
 * @param {() => void} [onDone] - Called after a successful booking (close the modal, refetch the lead, …).
 * @returns {(event: object) => Promise<void>}
 */
export default function useBookEvent(leadId, onDone) {
  const qc = useQueryClient();
  return useCallback(async (event) => {
    try {
      const { warnings } = await bookAppointment(leadId, event);
      toast.success('Event created and saved to your calendar');
      warnings.forEach((w) => toast(w, { icon: '⚠️', duration: 7000 }));
      ['calendar', 'appointments', 'freebusy'].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Could not create the event');
    }
  }, [leadId, onDone, qc]);
}
